/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { UpdateReportDefinitionMutationRequest, UpdateReportDefinitionMutationResponse, UpdateReportDefinitionPathParams, UpdateReportDefinition400, UpdateReportDefinition404 } from "../models/UpdateReportDefinition";

export function getUpdateReportDefinitionUrl(id: UpdateReportDefinitionPathParams["id"]) {
  const res = { method: 'PUT', url: `/report-definitions/${id}` as const }
  return res
}

/**
 * @description Updates the report definition by its unique identifier. The definition must match the blueprint version of the existing entity. If isDefault is set to true, this definition will be set as the default for its report type and other defaults will be unset.
 * @summary Update report definition
 * {@link /report-definitions/:id}
 */
export async function updateReportDefinition(id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest, config: Partial<RequestConfig<UpdateReportDefinitionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, UpdateReportDefinitionMutationRequest>({ method : "PUT", url : getUpdateReportDefinitionUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}